var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/48px/Actions"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3063 23.4025L12 24L12.6976 23.4064C13.65 22.5978 22 15.3507 22 10.0495C22 4.49935 17.5228 0 12 0C6.47716 0 2 4.49935 2 10.0495C2 15.3506 10.35 22.5978 11.3063 23.4025ZM4.16234 10.0495C4.16724 5.70147 7.67341 2.17793 12 2.17301C16.3266 2.17797 19.8328 5.70147 19.8377 10.0495C19.8377 13.3757 14.7005 18.6988 12 21.1348C9.2996 18.6998 4.16234 13.3798 4.16234 10.0495ZM8.03613 10.0495C8.03613 12.2496 9.81084 14.0331 12 14.0331C14.1893 14.0331 15.964 12.2496 15.964 10.0495C15.964 7.84949 14.1893 6.06599 12 6.06599C9.81084 6.06599 8.03613 7.84949 8.03613 10.0495ZM10.0181 10.0495C10.0181 8.94947 10.9054 8.05772 12 8.05772C13.0947 8.05772 13.982 8.94947 13.982 10.0495C13.982 11.1495 13.0947 12.0413 12 12.0413C10.9054 12.0413 10.0181 11.1495 10.0181 10.0495Z",
    fill: "#3C5BD2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocpin);
export default __webpack_public_path__ + "static/media/ic_locpin.7baf50c4db00d3a90a531b074b2a8d17.svg";
export { ForwardRef as ReactComponent };